unable to read source [project]/node_modules/.pnpm/superstruct@2.0.2/node_modules/superstruct/src/struct.ts